module.exports = __webpack_public_path__ + "img/rip-graphic.14e1eea5.svg";